<template>
  <div>
    <van-nav-bar @click-left="clickBack" left-arrow />
    <van-dropdown-menu :close-on-click-outside="false">
      <van-dropdown-item :title="dropdownTitle" ref="dropmenu">
        <div class="screen-wrap-popup">
          <van-row class="screenwrap">
            <van-col :span="6"><div class="left">开始时间</div></van-col>
            <van-col :span="18"
              ><div class="input-content" @click="clickTime('starttime')">
                {{ starttime }}
              </div></van-col
            >
          </van-row>
          <van-row class="screenwrap">
            <van-col :span="6"><div class="left">结束时间</div></van-col>
            <van-col :span="18"
              ><div class="input-content" @click="clickTime('endtime')">
                {{ endtime }}
              </div></van-col
            >
          </van-row>
          <van-row class="screenwrap" v-if="personType == 12">
            <van-col :span="6"><div class="left">选择孩子</div></van-col>
            <van-col :span="18">
              <van-radio-group v-model="radio" direction="horizontal">
                <van-radio
                  :name="item"
                  style="margin: 0.5rem;"
                  v-for="(item, index) in childList"
                  :key="index"
                  >{{ item.name }}</van-radio
                >
              </van-radio-group>
            </van-col>
          </van-row>
          <van-row :gutter="20" style="margin-top: 10px;">
            <van-col :span="12"
              ><van-button block @click="$refs.dropmenu.toggle()"
                >取消</van-button
              ></van-col
            >
            <van-col :span="12"
              ><van-button type="info" block @click="handleShowData"
                >确定</van-button
              ></van-col
            >
          </van-row>
        </div>
      </van-dropdown-item>
    </van-dropdown-menu>
    <div class="statistics">
      <div class="list">
        <div class="item">
          <div>正常出勤</div>
          <div class="bottom">
            <span class="num">{{ data.normal || 0 }}</span
            ><span>天</span>
          </div>
        </div>
        <div class="item">
          <div>应出勤</div>
          <div class="bottom">
            <span class="num">{{ data.attendance || 0 }}</span
            ><span>天</span>
          </div>
        </div>
        <div class="item">
          <div>实际出勤</div>
          <div class="bottom">
            <span class="num">{{ data.duration || 0 }}</span
            ><span>小时</span>
          </div>
        </div>
      </div>
    </div>
    <div class="wrap">
      <van-collapse v-model="activeNames">
        <van-collapse-item
          v-for="(item, index) in listStatus.filter((item) => item.num > 0)"
          :key="index"
          :title="item.title"
          :name="item.name"
          :disabled="item.listContent.length <= 0"
          size="large"
        >
          <div class="collapse-cell" v-for="v in item.listContent">
            {{ v.value }}
          </div>
        </van-collapse-item>
      </van-collapse>
    </div>
    <SelectTime
      ref="starttime"
      :typeTime="'选择开始时间'"
      @time="handleTimeStartConfirm"
      :minDate="minDate"
      :maxDate="new Date()"
      type="date"
      :currentDate="startMinTime"
    />
    <SelectTime
      ref="endtime"
      :typeTime="'选择结束时间'"
      @time="handleTimeEndConfirm"
      :minDate="minDate"
      type="date"
      :currentDate="endCurTime"
      :maxDate="new Date()"
    />
  </div>
</template>

<script>
import moment from 'moment'
import { compare, getDateYMD, timeFormart } from '@/utils'

import SelectTime from '@/components/subScribePopup/selectTime'
export default {
  data() {
    return {
      activeNames: ['1'],
      show: false,
      starttime: moment()
        .startOf('month')
        .format('YYYY-MM-DD'),
      endtime: moment().format('YYYY-MM-DD'),
      listStatus: [],
      minDate: new Date(2020, 1, 1),
      dropdownTitle: '',
      endCurTime: new Date(moment().format('YYYY-MM-DD')),
      data: {},
      childList: [],
      radio: {},
    }
  },
  computed: {
    startMinTime() {
      return new Date(moment().year(), moment().month(), 1) // 数字
    },
    personType() {
      return JSON.parse(localStorage.getItem('userInfo')).personType
    },
  },
  mounted() {
    if (this.personType == 12) {
      this.getAllChild()
    } else {
      this.getStatistics()
    }

    this.dropdownTitle = `${this.starttime}至${this.endtime}`
  },
  methods: {
    async getStatistics() {
      const { code, data, msg } = await this.$https.statistics({
        userId:
          this.personType == '13' ? this.$store.state.userId : this.radio.id,
        startTime: this.starttime,
        endTime: this.endtime,
      })
      if (code !== 200) {
        this.$toast(msg)
        this.listStatus = []
        this.data = {}
        return
      }
      this.data = data
      // this.$toast().clear()
      this.listStatus = [
        {
          title: `迟到${data.lateNumber}次`,
          listContent: data.listLate.map((item) => {
            item.value = `${getDateYMD(item.signinTime)}迟到${
              item.lateTime
            }分钟`
            return item
          }),
          num: data.lateNumber,
          name: 1,
        },
        {
          title: `未打卡${data.frequency}次`,
          listContent: data.listMissed.map((item) => {
            item.value = `${getDateYMD(item.punchTime)}${item.punchType}未打卡`
            return item
          }),
          num: data.frequency,
          name: 2,
        },
        {
          title: `加班${data.workNumber}次`,
          listContent: data.listOverTimeHistory.map((item) => {
            item.value = `${getDateYMD(item.lastClockTime)}加班${
              item.overTime
            }小时`
            return item
          }),
          num: data.workNumber,
          name: 3,
        },
        {
          title: `早退${data.leaveEarly}次`,
          listContent: data.listEarlyHistory.map((item) => {
            item.value = `${getDateYMD(item.earlyTime)}早退${item.duration}分钟`
            return item
          }),
          num: data.leaveEarly,
          name: 4,
        },
        // {
        //   title: `缺勤${data.absence}次`,
        //   listContent: data.listAbsenceHistory.map((item) => {
        //     item.value = `${getDateYMD(item.absenceDate)}缺勤`
        //     return item
        //   }),
        //   num: data.absence,
        //   name: 5,
        // },
        {
          title: `请假${data.leaveNumber}次`,
          listContent: data.listLeave
            ? data.listLeave.map((item) => {
                item.value = `${getDateYMD(item.startTime)}至${getDateYMD(
                  item.endTime
                )}请假`
                return item
              })
            : [],
          num: data.leaveNumber,
          name: 6,
        },
        // {
        //   title: `外勤${data.absence}次`,
        //   num: data.absence,
        //   listContent: [],
        //   name: 7,
        // },
      ]
    },
    clickBack() {
      this.$router.go(-1)
    },
    clickSelStartTime() {},
    clickSelEndTime() {},
    clickTime(type) {
      this.$refs[type].showTimePopup = true
    },
    handleShowData() {
      const start = moment(this.starttime, 'YYYY-MM-DD')
      const end = moment(this.endtime, 'YYYY-MM-DD')
      console.log(end.diff(start, 'day'))
      if (end.diff(start, 'day') > 31) {
        this.$toast('最大时间为31天')
        return false
      }
      this.dropdownTitle = `${this.starttime}至${this.endtime}`
      this.$refs.dropmenu.toggle()

      this.getStatistics()
    },
    handleTimeStartConfirm(value) {
      console.log(value)
      this.starttime = value
    },
    handleTimeEndConfirm(value) {
      this.endtime = value
    },
    calculateTime(StatusMinute) {
      var hour = parseInt((StatusMinute / 60) % 24)
      var min = parseInt(StatusMinute % 60)
      StatusMinute = ''
      if (hour > 0) {
        StatusMinute += hour + '小时'
      }
      if (min > 0) {
        StatusMinute += parseFloat(min) + '分钟'
      }
      return `${StatusMinute}`
    },
    async getAllChild() {
      const { code, data } = await this.$https.getAllChild({
        userId: this.$store.state.userId,
        schoolId: this.$store.state.schoolId,
      })
      if (code !== 200) {
        return
      }
      this.childList = data
      this.radio = data[0]
      if (this.radio.id) {
        this.getStatistics()
      }
      // this.$set(this.form, 'radio', data[0])
    },
  },
  components: {
    SelectTime,
  },
}
</script>

<style lang="scss" scoped>
.wrap {
  margin: 1rem;
  margin-top: 2rem;
  border-radius: 0.75rem;
  overflow: hidden;
  .collapse-cell {
    padding: 0.5rem 0rem;
    border-bottom: 1px solid #f4f4f6;
    &:last-child {
      border-bottom: none;
    }
  }
}
.statistics {
  margin: 1rem;

  .list {
    display: flex;
    background: #fff;
    border-radius: 0.75rem;
    box-shadow: 0rem 1rem 1rem rgba(69, 91, 99, 0.03);
    .item {
      flex: 1;
      text-align: center;
      padding: 0 0.85rem;
      margin: 1rem 0;
      font-size: 0.75rem;
      color: #999;
      border-right: 1px solid #f4f4f6;
      &:nth-child(3n) {
        border-right: none;
      }
      .bottom {
        margin-top: 0.5rem;
        .num {
          font-size: 1.5rem;
          color: #1989fa;
          margin-right: 0.3rem;
        }
      }
    }
  }
}
.menu-wrap {
  padding: 1rem;
  .sel-date {
    text-align: center;
    background: #f4f4f6;
    padding: 1rem 0.8rem;
    border-radius: 1.5rem;
    margin: 2rem 0;
    font-size: 0.85rem;
  }
}
.screen-wrap-popup {
  padding: 20px;
  .screenwrap {
    padding: 0.5rem 1rem;
    .left {
      /* display; */
      /* padding: 0.7rem 0; */
      font-size: 0.8rem;
      vertical-align: middle;
      height: 2.3rem;
      line-height: 2.3rem;
    }
    .input-content {
      background: #f4f4f6;
      padding: 0rem 1rem;
      border-radius: 2rem;
      height: 2.3rem;
      line-height: 2.3rem;
    }
  }
  .screen-title {
    text-align: center;
    color: #999;
    font-size: 1rem;
  }
}
</style>
